import {
  BarChart3,
  FileText,
  ListChecks,
  Palette,
  Send,
  Users,
  type LucideIcon,
} from 'lucide-react';

/** A step of the campaign page, in the order they are worked through. */
export type CampaignStepId = 'details' | 'design' | 'questions' | 'guests' | 'send' | 'results';

export interface CampaignStep {
  id: CampaignStepId;
  label: string;
  /** One line under the label on the rail. */
  hint: string;
  icon: LucideIcon;
  /** The office's alone: a client runs the campaign but not its questions and meals. */
  officeOnly?: boolean;
}

export const CAMPAIGN_STEPS: CampaignStep[] = [
  { id: 'details', label: 'Details', hint: 'Name, message, deadline', icon: FileText },
  { id: 'design', label: 'Design', hint: 'Artwork, envelope, colours', icon: Palette },
  {
    id: 'questions',
    label: 'Questions & meals',
    hint: 'What guests are asked',
    icon: ListChecks,
    officeOnly: true,
  },
  { id: 'guests', label: 'Guests', hint: 'Who is invited', icon: Users },
  { id: 'send', label: 'Review & send', hint: 'Test, send or schedule', icon: Send },
  { id: 'results', label: 'Results', hint: 'Who answered, and how', icon: BarChart3 },
];

/** The steps a viewer works through — a client has no questions-and-meals step. */
export function campaignStepsFor(clientMode: boolean): CampaignStep[] {
  return CAMPAIGN_STEPS.filter((step) => !clientMode || !step.officeOnly);
}

/**
 * The step asked for, when it is one this viewer has; otherwise where a
 * campaign is picked up — its results once it went out, its details before.
 */
export function resolveCampaignStep(
  asked: string | null | undefined,
  clientMode: boolean,
  sent: boolean,
): CampaignStepId {
  const steps = campaignStepsFor(clientMode);
  const found = steps.find((step) => step.id === asked);
  if (found) return found.id;
  return sent ? 'results' : 'details';
}
